/**
 * main.js - JavaScript principal custom
 * Gère : annulation abonnement, prix membres, cart checkout, popup, panier abandonné
 */

'use strict';

// =============================================
// UTILITAIRES GLOBAUX
// =============================================

const CC = window.ccSettings || {};
const API_URL = CC.apiUrl || '';
const LOCALE = CC.locale || 'fr';
const LOCALE_PREFIX = CC.localePrefix || '';
const VARIANT_ID = CC.checkoutVariantId || 0;
const SHIP_PRICE = CC.shipPrice || 0;

function ccApiPost(endpoint, body) {
  return fetch(API_URL + '/' + endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(Object.assign({ shopify_locale: LOCALE }, body))
  }).then(function(r) { return r.json(); });
}

function ccApiGet(endpoint, params) {
  const qs = new URLSearchParams(Object.assign({ shopify_locale: LOCALE }, params)).toString();
  return fetch(API_URL + '/' + endpoint + '?' + qs).then(function(r) { return r.json(); });
}

// Créer et afficher une popup modale
function showModal(title, message, onClose) {
  var existing = document.getElementById('cc-modal-overlay');
  if (existing) existing.remove();

  var overlay = document.createElement('div');
  overlay.className = 'cc-modal-overlay';
  overlay.id = 'cc-modal-overlay';
  overlay.innerHTML =
    '<div class="cc-modal" role="dialog" aria-modal="true">' +
      '<button class="cc-modal__close" aria-label="Fermer">&times;</button>' +
      '<h2 class="cc-modal__title">' + (title || '') + '</h2>' +
      '<p class="cc-modal__message">' + (message || '') + '</p>' +
    '</div>';

  document.body.appendChild(overlay);

  function closeModal() {
    overlay.classList.add('hidden');
    overlay.remove();
    if (typeof onClose === 'function') onClose();
  }

  overlay.querySelector('.cc-modal__close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
}

// Gérer l'affichage du loader dans un bouton
function setButtonLoading(btn, loading) {
  if (!btn) return;
  if (loading) {
    btn.dataset.originalText = btn.innerHTML;
    btn.innerHTML = '<span class="cc-loader"></span>';
    btn.disabled = true;
  } else {
    btn.innerHTML = btn.dataset.originalText || btn.innerHTML;
    btn.disabled = false;
  }
}

// Formater un montant en euros
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
}

// Récupérer les données client du localStorage
function getStoredCustomer() {
  try {
    var data = localStorage.getItem('cc_customer');
    return data ? JSON.parse(data) : null;
  } catch(e) { return null; }
}

// Stocker les données client dans localStorage
function storeCustomer(data) {
  try { localStorage.setItem('cc_customer', JSON.stringify(data)); } catch(e) {}
}

// Supprimer les données client
function clearCustomer() {
  localStorage.removeItem('cc_customer');
  localStorage.removeItem('cc_cart_data');
}

// Vérifier si le client a un abonnement actif
function hasActiveSubscription() {
  var customer = getStoredCustomer();
  if (!customer || !customer.purchase) return false;
  var status = (customer.purchase.status || '').toUpperCase();
  return ['ACTIVE', 'TRIAL', 'RECYCLE_BILLING'].includes(status);
}

// Récupérer/stocker les données cart drawer form
function getStoredCartData() {
  try {
    var data = localStorage.getItem('cc_cart_data');
    return data ? JSON.parse(data) : {};
  } catch(e) { return {}; }
}

function storeCartData(data) {
  try { localStorage.setItem('cc_cart_data', JSON.stringify(data)); } catch(e) {}
}

// =============================================
// ANNULATION D'ABONNEMENT (FOOTER)
// =============================================

function initCancelSubscriptionForm() {
  var form = document.getElementById('cc-cancel-sub-form');
  if (!form) return;

  var emailInput = form.querySelector('#cc-cancel-email');
  var submitBtn = form.querySelector('#cc-cancel-submit');
  var messageEl = form.querySelector('#cc-cancel-message');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;

    setButtonLoading(submitBtn, true);
    if (messageEl) { messageEl.textContent = ''; messageEl.style.display = 'none'; }

    ccApiPost('cancel_subscription.php', { emailAddress: email, adresseEmail: email })
      .then(function(data) {
        setButtonLoading(submitBtn, false);
        var msg = data.message || '';
        if (messageEl) {
          messageEl.textContent = msg;
          messageEl.style.display = 'block';
          messageEl.style.color = data.success ? 'inherit' : '#c83232';
        }
        // Si connecté, rafraîchir les données du compte client
        var customer = getStoredCustomer();
        if (customer && customer.customer && customer.customer.emailAddress === email) {
          refreshCustomerData(customer.customer.emailAddress, null, customer._orderId);
        }
      })
      .catch(function(err) {
        setButtonLoading(submitBtn, false);
        if (messageEl) {
          messageEl.textContent = 'Une erreur est survenue. Veuillez réessayer.';
          messageEl.style.display = 'block';
          messageEl.style.color = '#c83232';
        }
      });
  });
}

// =============================================
// PRIX MEMBRES (50% REDUCTION)
// =============================================

function applyMemberPricing() {
  if (!hasActiveSubscription()) return;

  // Prix sur cartes produits / page produit uniquement (PAS les cart items)
  var priceContainers = document.querySelectorAll('.price');
  priceContainers.forEach(function(container) {
    // Ignorer les prix à l'intérieur d'un cart-item (drawer ou page panier)
    if (container.closest('.cart-item') || container.closest('.cart-items')) return;

    // Ignorer le produit d'abonnement
    var productCard = container.closest('[data-product-id]');
    if (productCard && productCard.dataset.productId == CC.checkoutProductId) return;
    if (container.dataset.productId == CC.checkoutProductId) return;

    if (container.dataset.memberPriceApplied) return;
    container.dataset.memberPriceApplied = '1';

    var regularItem = container.querySelector('.price-item--regular');
    if (!regularItem) return;

    var priceText = regularItem.textContent.trim();
    var match = priceText.match(/[\d\s,\.]+/);
    if (!match) return;

    var cleanPrice = match[0].replace(/\s/g, '').replace(',', '.');
    var priceCents = Math.round(parseFloat(cleanPrice) * 100);
    if (isNaN(priceCents) || priceCents <= 0) return;

    // Floor pour le prix payé (comme CheckoutChamp), ceil pour la remise
    var halfPrice = Math.floor(priceCents / 2);
    var halfFormatted = formatMoney(halfPrice);
    var originalFormatted = formatMoney(priceCents);

    container.classList.add('price--on-sale');

    var priceContainer = container.querySelector('.price__container');
    if (!priceContainer) return;

    var salePriceDiv = null;
    var children = priceContainer.children;
    for (var ci = 0; ci < children.length; ci++) {
      if (children[ci].classList.contains('price__sale')) {
        salePriceDiv = children[ci];
        break;
      }
    }
    if (!salePriceDiv) {
      salePriceDiv = document.createElement('div');
      salePriceDiv.className = 'price__sale';
      priceContainer.appendChild(salePriceDiv);
    }

    salePriceDiv.innerHTML =
      '<span class="visually-hidden visually-hidden--inline">Prix normal</span>' +
      '<span><s class="price-item price-item--regular">' + originalFormatted + '</s></span>' +
      '<span class="visually-hidden visually-hidden--inline">Prix membre</span>' +
      '<span class="price-item price-item--sale price-item--last">' + halfFormatted + '</span>' +
      '<span class="cc-member-price-badge">-50%</span>';
  });
}

// =============================================
// PANIER - INTERCEPTION CHECKOUT BUTTON
// =============================================

function initCartCheckoutInterception() {
  // Délégation sur document (capture) : survit aux re-renders de section Shopify
  // Gère TOUS les boutons [type="submit"][name="checkout"] (drawer + page panier)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[type="submit"][name="checkout"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Sauvegarder le formulaire si la fonction est disponible (main-cart-footer.liquid)
    if (typeof window.ccCartSaveForm === 'function') window.ccCartSaveForm();

    handleCartCheckout(btn);
  }, true);
}

function showAddressSuggestions(infoData, btn, onSelect) {
  var existing = document.getElementById('cc-address-suggestions-overlay');
  if (existing) existing.remove();

  var isEn = LOCALE && LOCALE.toLowerCase().startsWith('en');
  var suggestions = infoData.addressSuggestions || [];

  var titleText     = isEn ? 'Select your address' : 'Sélectionnez votre adresse';
  var msgText       = infoData.message || (isEn ? 'Please select the correct address.' : 'Veuillez sélectionner la bonne adresse.');
  var useMyAddrText = isEn ? 'Use my address as entered' : 'Utiliser mon adresse telle que saisie';

  var suggestionsHtml = suggestions.map(function(s, i) {
    // Toujours construire le label depuis les champs réels (street/postcode/city)
    // pour que ce qui est affiché corresponde exactement à ce qui sera rempli dans le formulaire
    var label = s.street + (s.building ? ', ' + s.building : '') + ', ' + s.postcode + ' ' + s.city;
    return '<button type="button" class="cc-address-suggestion-btn" data-idx="' + i + '">' + label + '</button>';
  }).join('');

  var overlay = document.createElement('div');
  overlay.id = 'cc-address-suggestions-overlay';
  overlay.className = 'cc-modal-overlay';
  overlay.innerHTML =
    '<div class="cc-modal" role="dialog" aria-modal="true" style="max-width:520px;width:92%;max-height:80vh;overflow-y:auto;">' +
      '<button type="button" class="cc-modal__close" aria-label="Fermer">&times;</button>' +
      '<h2 class="cc-modal__title">' + titleText + '</h2>' +
      '<p style="margin-bottom:1.5rem;font-size:1.3rem;">' + msgText + '</p>' +
      '<div class="cc-address-suggestions-list">' + suggestionsHtml + '</div>' +
      '<button type="button" class="cc-address-bypass-btn">' + useMyAddrText + '</button>' +
    '</div>';

  document.body.appendChild(overlay);

  function closeOverlay() {
    overlay.remove();
    setButtonLoading(btn, false);
  }

  overlay.querySelector('.cc-modal__close').addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeOverlay(); });

  overlay.querySelectorAll('.cc-address-suggestion-btn').forEach(function(btnEl) {
    btnEl.addEventListener('click', function() {
      var idx = parseInt(this.dataset.idx);
      var selected = suggestions[idx];
      overlay.remove();
      if (typeof onSelect === 'function') onSelect(selected);
    });
  });

  overlay.querySelector('.cc-address-bypass-btn').addEventListener('click', function() {
    overlay.remove();
    if (typeof onSelect === 'function') onSelect(null);
  });
}

function handleCartCheckout(btn) {
  setButtonLoading(btn, true);

  var cartData = getStoredCartData();
  cartData.pixel = '';
  cartData.shipProfileId = CC.shipProfilId || '';
  cartData.has_subscription = '0';
  storeCartData(cartData);

  var customer = getStoredCustomer();
  var customerIsSubscribed = !!(customer && customer.customer) && hasActiveSubscription();

  // Lire les champs du formulaire (page panier ou tiroir)
  function getFieldVal(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  var emailInput = document.getElementById('cc-cart-email') ||
                   document.getElementById('cc-drawer-email');
  var email = emailInput ? emailInput.value.trim() : '';

  var customerInfoBody = {
    emailAddress:       email,
    shippingFirstName:  getFieldVal('cc-cart-firstname'),
    shippingLastName:   getFieldVal('cc-cart-lastname'),
    shippingAddress1:   getFieldVal('cc-cart-address1'),
    shippingAddress2:   getFieldVal('cc-cart-address2'),
    shippingPostalCode: getFieldVal('cc-cart-postalcode'),
    shippingCity:       getFieldVal('cc-cart-city'),
    shippingCountry:    getFieldVal('cc-cart-country'),
    phone:              getFieldVal('cc-cart-phone'),
    isF:                true,
    shopify_locale:     LOCALE
  };

  var fieldMap = {
    emailAddress:       'cc-cart-email',
    shippingFirstName:  'cc-cart-firstname',
    shippingLastName:   'cc-cart-lastname',
    shippingAddress1:   'cc-cart-address1',
    shippingPostalCode: 'cc-cart-postalcode',
    shippingCity:       'cc-cart-city',
    shippingCountry:    'cc-cart-country',
    phone:              'cc-cart-phone'
  };

  function showFormErrors(infoData) {
    var errorEl = document.getElementById('cc-cart-form-error');
    if (errorEl) {
      var isEn = LOCALE && LOCALE.toLowerCase().startsWith('en');
      var defaultMsg = isEn ? 'Errors were found in the form.' : 'Des erreurs ont été détectées dans le formulaire.';
      var html = '<strong>' + (infoData.message || defaultMsg) + '</strong>';
      if (infoData.errors && typeof infoData.errors === 'object' && Object.keys(infoData.errors).length > 0) {
        html += '<ul style="margin:0.5rem 0 0; padding-left:1.5rem; font-size:1.2rem;">';
        Object.keys(infoData.errors).forEach(function(f) {
          html += '<li>' + infoData.errors[f] + '</li>';
        });
        html += '</ul>';
      }
      errorEl.innerHTML = html;
      errorEl.style.display = 'block';
      errorEl.classList.add('visible');
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    Object.keys(fieldMap).forEach(function(f) {
      var el = document.getElementById(fieldMap[f]);
      if (el) el.style.borderColor = '';
    });
    if (infoData.errors && typeof infoData.errors === 'object') {
      Object.keys(infoData.errors).forEach(function(f) {
        var el = fieldMap[f] ? document.getElementById(fieldMap[f]) : null;
        if (el) el.style.borderColor = '#c83232';
      });
    }
  }

  // Déterminer les appels API nécessaires :
  // - customer_info.php : TOUJOURS (valide le formulaire, même si abonné)
  // - subscription_check.php : seulement si pas encore connu (cas 3)
  var needsSubApiCheck = !customerIsSubscribed && email && email.includes('@');

  var apiCalls = [ccApiPost('customer_info.php', customerInfoBody)];
  if (needsSubApiCheck) {
    apiCalls.push(ccApiPost('subscription_check.php', { emailAddress: email, email: email }));
  }

  // Récupérer l'état du panier en parallèle
  Promise.all([
    fetch('/cart.js').then(function(r) { return r.json(); }),
    Promise.all(apiCalls)
  ])
  .then(function(outer) {
    var cart     = outer[0];
    var apiRes   = outer[1];
    var infoData = apiRes[0];
    var subData  = apiRes[1]; // undefined si pas appelé

    var hasSubInCart = (cart.items || []).some(function(i) { return i.variant_id == VARIANT_ID; });

    setButtonLoading(btn, false);

    // Logique de redirection après validation (adresse confirmée)
    function proceedToSubscriptionCheck() {
      // CAS 1 : compte client connecté avec abonnement actif
      if (customerIsSubscribed) {
        cartData.has_subscription = '1';
        storeCartData(cartData);
        if (hasSubInCart && VARIANT_ID) {
          removeSubscriptionFromCart(redirectToCheckout);
        } else {
          redirectToCheckout();
        }
        return;
      }

      // CAS 2 : abonnement déjà dans le panier
      if (hasSubInCart) {
        redirectToCheckout();
        return;
      }

      // CAS 3 : résultat de subscription_check.php
      if (subData && subData.success) {
        var cd = getStoredCartData();
        cd.has_subscription = '1';
        storeCartData(cd);
        redirectToCheckout();
      } else {
        redirectToUpsell();
      }
    }

    // 1. Valider le formulaire — PRIORITÉ ABSOLUE, quel que soit le statut d'abonnement
    if (!infoData.success) {
      // Cas spécial : l'API propose des suggestions d'adresse corrigée
      if (infoData.showSuggestions && infoData.addressSuggestions && infoData.addressSuggestions.length > 0) {
        showAddressSuggestions(infoData, btn, function(selectedAddress) {
          if (selectedAddress) {
            // Pré-remplir les champs avec l'adresse sélectionnée
            var addr1El  = document.getElementById('cc-cart-address1');
            var addr2El  = document.getElementById('cc-cart-address2');
            var postalEl = document.getElementById('cc-cart-postalcode');
            var cityEl   = document.getElementById('cc-cart-city');
            if (addr1El)  addr1El.value  = selectedAddress.street   || '';
            if (addr2El && selectedAddress.building) addr2El.value = selectedAddress.building;
            if (postalEl) postalEl.value = selectedAddress.postcode || '';
            if (cityEl)   cityEl.value   = selectedAddress.city     || '';
            // Sauvegarder le formulaire mis à jour si disponible
            if (typeof window.ccCartSaveForm === 'function') window.ccCartSaveForm();
          }
          // Poursuivre le flux de checkout (adresse confirmée ou ignorée)
          proceedToSubscriptionCheck();
        });
        return;
      }
      // Erreurs classiques (champs manquants, email invalide, etc.)
      showFormErrors(infoData);
      return;
    }

    // 2. Formulaire valide → vérifier l'abonnement
    proceedToSubscriptionCheck();
  })
  .catch(function() {
    setButtonLoading(btn, false);
    redirectToUpsell();
  });
}

function removeSubscriptionFromCart(callback) {
  if (!VARIANT_ID) { if (callback) callback(); return; }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 })
  }).then(callback).catch(callback);
}

function redirectToCheckout() {
  var prefix = LOCALE_PREFIX || '';
  window.location.href = window.location.protocol + '//' + window.location.host + prefix + '/pages/checkout';
}

function redirectToUpsell() {
  var prefix = LOCALE_PREFIX || '';
  window.location.href = window.location.protocol + '//' + window.location.host + prefix + '/pages/coffret-cadeau';
}

// =============================================
// MISE A JOUR ATTRIBUTS PANIER
// =============================================

function updateCartAttributes(attributes, callback) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) { if (callback) callback(null, data); })
  .catch(function(err) { if (callback) callback(err); });
}

// =============================================
// CHECKOUT PAGE PANIER (intercept global)
// =============================================

// Exposer handleCartPageCheckout pour que main-cart-footer.liquid puisse l'appeler
function handleCartPageCheckout(btn) {
  handleCartCheckout(btn);
}

// =============================================
// RAFRAICHIR LES DONNEES CLIENT
// =============================================

function refreshCustomerData(email, callback, orderId) {
  var customer = getStoredCustomer();
  var oid = orderId || (customer ? customer._orderId : '');
  if (!email || !oid) { if (callback) callback(); return; }

  ccApiPost('account.php', {
    emailAddress: email, adresseEmail: email,
    orderId: oid, order_id: oid
  })
  .then(function(data) {
    if (data.customer) {
      var stored = getStoredCustomer() || {};
      stored.customer = data.customer;
      stored.orders = data.orders;
      stored.purchase = data.purchase;
      stored._orderId = oid;
      storeCustomer(stored);
    }
    if (callback) callback(data);
  })
  .catch(function() { if (callback) callback(); });
}

// =============================================
// GESTION DU PANIER ABANDONNÉ (CHECKOUT PAGE)
// =============================================

function handleAbandonedCart(urlParams, callback) {
  var productsParam = urlParams.get('products');
  if (!productsParam) { if (callback) callback(false); return; }

  // Parser les produits: format "id:qty;id:qty"
  var productPairs = productsParam.split(';');
  var productsArray = productPairs.map(function(p) {
    var parts = p.split(':');
    return { id: parts[0], quantity: parseInt(parts[1]) || 1 };
  }).filter(function(p) { return p.id; });

  if (!productsArray.length) { if (callback) callback(false); return; }

  var campaignId = urlParams.get('campaignId') || String(CC.campaignId || '');

  // Appel API pour convertir les IDs CC en IDs Shopify
  ccApiPost('abandonned_cart.php', {
    campaignId: campaignId,
    products: productsArray
  })
  .then(function(data) {
    if (data.status !== 'success' || !data.products || !data.products.length) {
      if (callback) callback(false);
      return;
    }

    var addedProducts = data.products;

    // Vider le panier puis ajouter les produits
    fetch('/cart/clear.js', { method: 'POST' })
    .then(function() {
      var addItems = addedProducts.map(function(p) {
        return { id: p.shopify_variant_id, quantity: p.quantity };
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addItems })
      });
    })
    .then(function() {
      // Déterminer has_subscription
      var hasSubProduct = addedProducts.some(function(p) {
        return p.shopify_variant_id == CC.checkoutVariantId;
      });

      // Récupérer les données de livraison depuis l'URL
      var cartData = getStoredCartData();
      cartData.firstName = urlParams.get('firstName') || cartData.firstName || '';
      cartData.lastName = urlParams.get('lastName') || cartData.lastName || '';
      cartData.address1 = urlParams.get('address1') || cartData.address1 || '';
      cartData.address2 = urlParams.get('address2') || cartData.address2 || '';
      cartData.postalCode = urlParams.get('postalCode') || cartData.postalCode || '';
      cartData.city = urlParams.get('city') || cartData.city || '';
      cartData.country = urlParams.get('country') || cartData.country || '';
      cartData.email = urlParams.get('emailAddress') || cartData.email || '';
      cartData.phone = urlParams.get('phoneNumber') || cartData.phone || '';
      //cartData.originalCampaignId = urlParams.get('campaignId') || String(CC.campaignId || '');
      //cartData.forceMerchantId = urlParams.get('forceMerchantId') || '';
      cartData.pixel = urlParams.get('pixel') || '';
      cartData.shipProfileId = urlParams.get('shipProfileId') || String(CC.shipProfilId || '');
      cartData.has_subscription = hasSubProduct ? '1' : (urlParams.get('has_subscription') || '0');
      storeCartData(cartData);

      // Mettre à jour les attributs panier
      var attrs = {
        'Prénom': cartData.firstName,
        'Nom': cartData.lastName,
        'Adresse': cartData.address1,
        'Complément': cartData.address2,
        'Code postal': cartData.postalCode,
        'Ville': cartData.city,
        'Pays': cartData.country,
        'Email': cartData.email,
        'Téléphone': cartData.phone
      };

      updateCartAttributes(attrs, function() {
        if (callback) callback(true, cartData, addedProducts);
      });
    })
    .catch(function() { if (callback) callback(false); });
  })
  .catch(function() { if (callback) callback(false); });
}

// =============================================
// FACEBOOK PIXEL
// =============================================

function parsePixels(pixelString) {
  if (!pixelString) return [];
  try {
    return pixelString.split(';').map(function(p) {
      var parts = p.split(':');
      return { pixelId: parts[0], accessToken: parts[1] };
    }).filter(function(c) { return c.pixelId && c.accessToken; });
  } catch(e) { return []; }
}

function sendFbEvent(eventName, pixels, userData, customData) {
  pixels.forEach(function(cfg) {
    fetch('https://graph.facebook.com/v18.0/' + cfg.pixelId + '/events?access_token=' + cfg.accessToken, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: [{
          event_name: eventName,
          event_time: Math.floor(Date.now() / 1000),
          action_source: 'website',
          user_data: userData || {},
          custom_data: customData || {}
        }]
      })
    }).catch(function() {});
  });
}

function getClientIP(callback) {
  fetch('https://api.ipify.org?format=json')
    .then(function(r) { return r.json(); })
    .then(function(d) { callback(d.ip || ''); })
    .catch(function() { callback(''); });
}


// =============================================
// TOTAL PANIER (drawer) - correction avec abonnement à 0€
// =============================================

function updateCartDrawerTotal() {
  var totalEl = document.querySelector('.totals__total-value');
  if (!totalEl) return;

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var items = cart.items || [];
    var hasSubInCart = false;
    var nonSubTotal = 0;

    items.forEach(function(item) {
      if (item.variant_id == VARIANT_ID) {
        hasSubInCart = true;
      } else {
        nonSubTotal += item.final_line_price;
      }
    });

    var isActiveMember = hasActiveSubscription();
    var applyDiscount = isActiveMember || hasSubInCart;

    var discountEl    = document.getElementById('cc-drawer-member-discount');
    var discountAmtEl = document.getElementById('cc-drawer-discount-amt');

    if (applyDiscount) {
      // Diviser le TOTAL par 2 : floor pour le montant payé, ceil (= total - floor) pour la remise
      var discountedTotal = Math.floor(nonSubTotal / 2);
      var discountCents   = nonSubTotal - discountedTotal;
      totalEl.textContent = formatMoney(discountedTotal);
      if (discountEl)    discountEl.style.display = '';
      if (discountAmtEl) discountAmtEl.textContent = '-' + formatMoney(discountCents);
    } else {
      totalEl.textContent = formatMoney(nonSubTotal);
      if (discountEl) discountEl.style.display = 'none';
    }
  }).catch(function() {});
}

// =============================================
// RETIRER L'ABONNEMENT DU PANIER SI MEMBRE ACTIF
// =============================================

function removeSubscriptionIfMember() {
  if (!hasActiveSubscription() || !VARIANT_ID || window._ccRemovingSub) return;

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    var hasSubInCart = (cart.items || []).some(function(item) {
      return item.variant_id == VARIANT_ID;
    });
    if (!hasSubInCart) return;

    window._ccRemovingSub = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      window._ccRemovingSub = false;
      // Rafraîchir le contenu du drawer via Shopify sections API
      fetch('/cart?sections=cart-drawer')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data['cart-drawer']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
            var newInner = doc.getElementById('CartDrawer');
            var currentInner = document.getElementById('CartDrawer');
            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
            // Mettre à jour le compteur du panier
            var countEl = document.getElementById('cart-icon-bubble');
            var newCount = doc.querySelector('.cart-count-bubble');
            if (countEl && newCount) {
              countEl.querySelector('.cart-count-bubble') && countEl.querySelector('.cart-count-bubble').replaceWith(newCount.cloneNode(true));
            }
          }
          updateCartDrawerTotal();
        })
        .catch(function() { updateCartDrawerTotal(); });
    })
    .catch(function() { window._ccRemovingSub = false; });
  }).catch(function() {});
}

// =============================================
// OBSERVATEUR DU DRAWER (mise à jour dynamique)
// =============================================

function initCartObserver() {
  // Drawer : observer #CartDrawer (stable — non remplacé par Shopify)
  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    var drawerTimer = null;
    new MutationObserver(function(mutations) {
      if (window._ccRemovingSub) return;
      var hasChange = mutations.some(function(m) {
        return m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0);
      });
      if (!hasChange) return;
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(function() { updateCartDrawerTotal(); }, 50);
    }).observe(cartDrawerEl, { childList: true, subtree: true });
  }

  // Page panier : observer #main-cart-footer (son innerHTML est remplacé par Shopify
  // lors d'un changement de quantité, mais l'élément lui-même reste stable)
  var cartFooterEl = document.getElementById('main-cart-footer');
  if (cartFooterEl) {
    var footerTimer = null;
    new MutationObserver(function(mutations) {
      var hasChange = mutations.some(function(m) {
        return m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0);
      });
      if (!hasChange) return;
      clearTimeout(footerTimer);
      footerTimer = setTimeout(function() {
        if (typeof window.ccCartUpdateTotal === 'function') window.ccCartUpdateTotal();
      }, 50);
    }).observe(cartFooterEl, { childList: true, subtree: true });
  }
}

// =============================================
// INITIALISATION
// =============================================

document.addEventListener('DOMContentLoaded', function() {
  initCancelSubscriptionForm();
  initCartCheckoutInterception();
  applyMemberPricing();
  updateCartDrawerTotal();
  removeSubscriptionIfMember();
  initCartObserver();
});

// Exposer les fonctions utiles globalement pour les autres pages
window.parsePixels = parsePixels;
window.sendFbEvent = sendFbEvent;
window.getClientIP = getClientIP;
window.handleAbandonedCart = handleAbandonedCart;
window.showModal = showModal;
window.refreshCustomerData = refreshCustomerData;
window.handleCartPageCheckout = handleCartPageCheckout;
